(() => {
  if (window.__mayhemWheelCardsLoaded) return;
  window.__mayhemWheelCardsLoaded = true;

  const normalize = (value) => {
    let name = String(value || '').split('?')[0].split('/').pop().toLowerCase();
    name = name.replace(/_[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}(?=\.[a-z0-9]+$)/i, '');
    return name;
  };

  const stem = (value) => normalize(value).replace(/\.[^.]+$/, '');

  const selectedVehicleId = () => {
    const native=window.TWGFitmentPreview?.selectedVehicle();
    return native ? 'fg:'+JSON.stringify(native.query) : '';
  };
  const syncSizes = card => {
    const sizes = card.querySelector('.mayhem-wheel-card__sizes');
    if (!sizes) return;
    if (sizes.dataset.catalogSizes === undefined) sizes.dataset.catalogSizes = sizes.textContent.trim();
    const badge = card.querySelector('[data-mayhem-card-fitment]');
    if (badge?.dataset.state === 'pending' && card.dataset.mayhemFilteredVariants) delete card.dataset.mayhemFilteredVariants;
    let text = sizes.dataset.catalogSizes;
    if (selectedVehicleId()) {
      let matches = [];
      try { matches = JSON.parse(card.dataset.mayhemFilteredVariants || badge?.dataset.matchedVariants || '[]'); } catch {}
      text = ['fits', 'caution'].includes(badge?.dataset.state)
        ? [...new Set(matches.filter(row => ['fits', 'caution'].includes(row.state)).map(row => row.size).filter(Boolean))]
          .sort((a, b) => { const x = a.toLowerCase().split('x').map(Number), y = b.toLowerCase().split('x').map(Number); return x[0] - y[0] || x[1] - y[1]; }).join(' | ')
        : '';
    }
    if (sizes.textContent !== text) sizes.textContent = text;
  };

  const syncViewOnVehicle = (card) => {
    if (!card) return;
    syncSizes(card);
    const link = card.querySelector('[data-mayhem-card-view-on-vehicle]');
    const badge = card.querySelector('[data-mayhem-card-fitment]');
    if (!link || !badge) return;
    const vehicleId = selectedVehicleId();
    const sku = badge.dataset.sku;
    let matches = [];
    try { matches = JSON.parse(badge.dataset.matchedVariants || '[]'); } catch {}
    const previewAvailable = matches.find(row => row.sku === sku)?.previewAvailable === true;
    const eligible = Boolean(
      card.closest('#ResultsList .product-grid__item') &&
      vehicleId && sku && previewAvailable && !badge.hidden && ['fits', 'caution'].includes(badge.dataset.state)
    );
    if (link.hidden !== !eligible) link.hidden = !eligible;
    if (!eligible) return;
    const destination = new URL(link.dataset.baseUrl || link.getAttribute('href'), window.location.origin);
    link.dataset.baseUrl = destination.pathname;
    destination.search = '';
    const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewThemeId && /^\d+$/.test(previewThemeId)) destination.searchParams.set('preview_theme_id', previewThemeId);
    destination.hash = '';
    link.dataset.twgVisualizerSku = sku;
    link.href = destination.href;
  };

  const inferredMatch = (images, handle, lug) => {
    const styleNumber = handle.match(/-(\d{4}[a-z]?)(?:-|$)/i)?.[1];
    if (!styleNumber) return null;
    const pattern = new RegExp(`${styleNumber}[-_]?${lug}(?=[a-z])`, 'i');
    return images.find((candidate) => pattern.test(normalize(candidate.filename)));
  };

  const applyLugImage = (card) => {
    if (!card || card.dataset.mayhemImageApplied === 'true') return;
    const handle = card.dataset.handle;
    const lug = card.dataset.lug;
    if (!handle || !lug) return;

    const dataNode = card.querySelector('[data-mayhem-card-images]');
    const img = card.querySelector('.mayhem-wheel-card__image');
    if (!dataNode || !img) return;

    let images = [];
    try {
      images = JSON.parse(dataNode.textContent || '[]');
    } catch (_) {
      return;
    }

    const mapped = window.MayhemLugImages?.[handle]?.[lug];
    let match = null;

    if (Array.isArray(mapped)) {
      for (const preferred of mapped) {
        const preferredName = normalize(preferred);
        const preferredStem = stem(preferred);
        match = images.find((candidate) => {
          const candidateName = normalize(candidate.filename);
          return candidateName === preferredName || stem(candidateName) === preferredStem;
        });
        if (match) break;
      }
    }

    match ||= inferredMatch(images, handle, lug);

    if (match?.url) {
      img.src = match.url;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      card.dataset.mayhemImageApplied = 'true';
    }
  };

  const scan = (root) => {
    if (!root) return;
    if (root instanceof Element && root.matches('[data-mayhem-wheel-card]')) {
      applyLugImage(root);
      syncViewOnVehicle(root);
    }
    root.querySelectorAll?.('[data-mayhem-wheel-card]').forEach((card) => {
      applyLugImage(card);
      syncViewOnVehicle(card);
    });
  };

  const pendingRoots = new Set();
  let frame = 0;

  const flush = () => {
    frame = 0;
    for (const root of pendingRoots) scan(root);
    pendingRoots.clear();
  };

  const schedule = (root) => {
    if (!root) return;
    pendingRoots.add(root);
    if (!frame) frame = requestAnimationFrame(flush);
  };

  const start = () => {
    const root = document.getElementById('MainContent') || document.body;
    scan(root);

    const observer = new MutationObserver((mutations) => {
      let shouldSchedule = false;

      for (const mutation of mutations) {
        const card = mutation.target instanceof Element
          ? mutation.target.closest('[data-mayhem-wheel-card]')
          : null;
        if (card) syncViewOnVehicle(card);
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (
            node.matches('[data-mayhem-wheel-card]') ||
            node.querySelector('[data-mayhem-wheel-card]')
          ) {
            pendingRoots.add(node);
            shouldSchedule = true;
          }
        }
      }

      if (shouldSchedule && !frame) frame = requestAnimationFrame(flush);
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-state', 'data-sku', 'hidden', 'data-matched-variants', 'data-mayhem-filtered-variants'],
    });
    window.__mayhemWheelCardsObserver = observer;

    document.addEventListener(
      'click',
      async (event) => {
        if (!(event.target instanceof Element)) return;
        const finishLink = event.target.closest('.mayhem-wheel-card__swatches a[href]');
        if (!finishLink) return;
        const card = finishLink.closest('[data-mayhem-wheel-card]');
        const lug = card?.dataset.lug;
        if (!lug) return;

        event.preventDefault();
        const destination = new URL(finishLink.href, window.location.origin);
        const fallbackUrl = destination.toString();
        finishLink.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(`${destination.pathname.replace(/\/$/, '')}.js`, {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) throw new Error(String(response.status));
          const targetProduct = await response.json();
          const targetVariant = (targetProduct.variants || []).find((variant) => {
            const boltPattern = (variant.options || []).find((value) => /^\d+-/.test(String(value || '').trim()));
            return String(boltPattern || '').trim().startsWith(`${lug}-`);
          });
          if (targetVariant?.id) destination.searchParams.set('variant', targetVariant.id);
          window.location.assign(destination.toString());
        } catch {
          window.location.assign(fallbackUrl);
        }
      },
      true
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => schedule(event.target));
  window.addEventListener('mayhem:vehicle-changed', () => scan(document.getElementById('MainContent') || document.body));
  window.addEventListener('twg:vehicle-changed', () => scan(document.getElementById('MainContent') || document.body));
  window.addEventListener('pageshow', () => scan(document.getElementById('MainContent') || document.body));
  window.addEventListener('storage', (event) => {
    if (event.key === 'mayhem:selected-vehicle-id') scan(document.getElementById('MainContent') || document.body);
  });
})();

